import React, { useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const metrics = ["MMR", "NMR", "ANC4+", "Inst. Delivery", "LBW"];
const height = 20;
export default function DistrictBarComparison({ data }) {
    const [selectedMetric, setSelectedMetric] = useState("MMR");

    const districts = data.map((d) => d.district);
    const metricValues = data.map((d) => d[selectedMetric]);

    const chartData = {
        labels: districts,
        datasets: [
            {
                label: selectedMetric,
                data: metricValues,
                backgroundColor: "#4FA3F9",
                hoverBackgroundColor: "#3B82F6",
                borderRadius: 8,
                barThickness: 28,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: "#fff",
                titleColor: "#000",
                bodyColor: "#000",
                borderColor: "#e2e8f0",
                borderWidth: 1,
                padding: 10,
            },
            datalabels: false
        },
        scales: {
            x: {
                ticks: { color: "#334155", font: { size: 12 } },
                grid: { display: false },
            },
            y: {
                ticks: { color: "#64748b", font: { size: 11 } },
                grid: { color: "#f1f5f9" },
            },
        },
    };

    return (
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-4 w-full" 
        // style={{
        //     height: `${height}vh`,
        //     minHeight: "260px",   // prevent collapsing
        //     maxHeight: "400px",   // prevent overflow / x-axis cut
        // }}
        >
            <div className="flex items-center justify-between mb-3">
                <h2 className="text-base font-semibold text-slate-800">
                    District comparison – choose metric
                </h2>

                <select
                    value={selectedMetric}
                    onChange={(e) => setSelectedMetric(e.target.value)}
                    className="px-3 py-1.5 text-sm border border-slate-300 rounded-lg bg-white"
                >
                    {metrics.map((m) => (
                        <option key={m} value={m}>
                            {m}
                        </option>
                    ))}
                </select>
            </div>

            <p className="text-xs text-slate-500 mb-3">Click a bar to select district</p>

            <div className="" style={{
                height: `${height}vh`,
            }}>
                <Bar data={chartData} options={chartOptions} />
            </div>
        </div>
    );
}
